import * as React from 'react'
import styled from 'styled-components'
import Svg from './Svg'

function BaseComponent(props: any) {
  return (
    <Svg
      width={15}
      height={15}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.15 14V1H.85v13h1.3zm4 0V1h-1.3v13h1.3zm4-13v13h-1.3V1h1.3zm4 13V1h-1.3v13h1.3z"
        fill="currentColor"
      />
    </Svg>
  )
}

const SvgColumns = styled(BaseComponent)`
  outline: none;
`
export default SvgColumns
